var exports = {
  "$U": "xaee3c4fa--5d8ae9--headnote",
  "Im": "xaee3c4fa--5d8ae9--comment",
  "xA": "xaee3c4fa--5d8ae9--footnote",
  "Lw": "xaee3c4fa--5d8ae9--_empty",
  "rx": "xaee3c4fa--5d8ae9--controls-wrapper",
  "fb": "xaee3c4fa--5d8ae9--form-wrapper",
  "nK": "xaee3c4fa--5d8ae9--comments",
  "iE": "xaee3c4fa--5d8ae9--wrapper",
};

module.exports = exports;
